import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
// import { SalesInvoiceService } from "../../../services/salesinvoice.service";
import { Combo2Service, WorkOrderService, ExcelService } from "../../../services/index";
import { SalesInvoiceService } from "../../../services/salesinvoice.service";
import { PartyService, SalesOrderService, PurchaseOrderService } from "../../../services/index";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { dcBarcodePrint } from "../../Purchase/bitDc/dcBarcodePrint";


@Component({
  selector: "addEditInvoice",
  templateUrl: "./rangeStock.html",
})
export class rangeStock {
  @ViewChild("tbody1") tbody1;
  row: any;
  data: any;
  designdata: any = { indent_no: 0, totalmtr: 0, totalamt: 0 };
  qualityList: any;
  typeList: any;

  codeList: any;
  seasonList: any;
  execApi: boolean = true;
  show_det: string = 'style';
  singleVal: boolean = false;
  invoicedata: any = {
    design_no: "",
    color: "",
    style : "",
    type : "",
    range: "3",
    lump_no: 0
  };
  delPartyList: any;
  party_id: any;
  box: any;
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };
  designList: any;
  gr_tot : number = 0;
  invalidList: any = [];
  colorList: any = [];
  dataList = [];
  fabColorlist: any = [];
  fabColorTemplist: any = [];
  temp: any = [];

  invoiceTypeList = ["PROFORMA", "INVOICE"];
  fabstyleList = ["PLAIN", "MAPLE", "PLAIN DOBBY", "PRINTED", "CHECKS", "STRIPES"];
  widthList = ["36", "44", "58"];
  brandList = ["EXPOSE", "ARAZA"];
  styleList = ["FORMAL", "CASUAL"];
  fitList = ["COMFORT FIT", "RELAX FIT"];
  mode: string;
  saveEvent: any;
  agentList: any;
  bl = [];
  partyCodeList: any;
  isLoading: boolean = false;
  isChecked: boolean = false;
  sampleList = [{ name: "YES" }, { name: "NO" }];

  partyList = [];
  partyOrderno: any;
  order: any;
  sale_type: any;
  expand = true;
  to_sale_type: any;
  listSelected = [];
  isLoadMask: Promise<any>;
  @Input() _params: any;

  @Input() set params(val: any[]) {


    if (this.mode == "Convert") {
      this.invoicedata.mode = "Add";
    }

    if (this.mode == "Convert") {
      //  this.editInvoiceList();
      this.invoicedata.ref_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      //   this.oncheck(this.invoicedata.salesorder);
    }
    if (this.mode == "View" || this.mode == "Edit") {


      //    this.invoicedata.ref_date = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    }
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  @ViewChild("codeAuto") codeAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  OrderNoCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    private salesinvservice: WorkOrderService,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private modalService: BsModalService,
    private poservice: PurchaseOrderService,
    private partyService: PartyService,
    private salesOrdService: SalesOrderService,
    private excelService: ExcelService
  ) {
    this.row = {
      agent_name: "",
      shade: "",
      color: "",
      fab_no: "",
      fab_color: "",
      style: "",
      brand: "",
      sam_no: "",
    };
    this.data = {
      invoiceList: [],
    };
  }
  ngOnInit() {
    //(<any>$("#tableres")).colResizable({liveDrag:true});

    this.tableScroll();
    this.invoicedata.mode = this.mode;

    console.log(this.mode)
    this.invoicedata.ref_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");

    this.getRangeList();

  }
  ngAfterViewInit() {
    $("#invoice_type").focus();
  }
  tableScroll() {
    $(".invoiceTable").height(window.innerHeight - 400);
    $(".invoiceTable").width(window.innerWidth - 30);
  }

  onEnterKeyPressed(nextEl: string) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      // let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      // a.removeClass('mat-autocomplete-visible');
      setTimeout(() => {
        $("#" + nextEl).focus();
      }, 500);
    }
  }

  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind;
    let nxtRow = $("#row-" + ind).next("tr");
    if (fld == "bar" && nxtRow.length == 0) {
      let rowdetail = Object.assign({}, this.row);
      nxtInd = nxtInd + 1;
      $("#" + "bar" + "-" + nxtInd).focus();
    } else {
      setTimeout(() => {
        let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
        a.removeClass("mat-autocomplete-visible");
        $("#" + fld + "-" + nxtInd).focus();
      }, 100);
    }
  }

  isRowEmpty(ind) {
    let data = this.data.invoiceList;
    for (let i = 0; i < data.length; i++) {
      if (data[i + 1].design_no != "") {
        return true;
      } else {
        return false;
      }
    }
  }

  // exportToExcel($event) {
  //   this.excelService.exportAsExcelFile(this.data.invoiceList, "Fabric Stock Range");
  // }
  // printDesigns(){

  //   console.log(this.data.invoiceList.filter(e=> e.is_checked == true))
  // }

  bsModalRef: BsModalRef;
  printDesigns() {

    let data = this.data.invoiceList.filter(e => e.is_checked == true);
    let params = {
      print_data: JSON.stringify(data)
    }
    // this.salesOrdService.sizelimitStkprint(params).then(function (res: any) { })
    data.map(e=> e.page_type = 'range_stock')
    this.bsModalRef = this.modalService.show(dcBarcodePrint, {
      keyboard: false,
      ignoreBackdropClick: true,
      class: "modal-lg compWidth-96"
    });
    this.bsModalRef.content.printdt = Object.assign([], data);


  }

  designChecked(event, i) {
    console.log(i, event.target.checked, this.data.invoiceList)
  }
  showSingleLumps() {
    console.log(this.singleVal)
    this.temp = [];

    if (!this.singleVal && this.data.invoiceList.length > 0) {

      this.data.invoiceList.forEach(el => {
        if (el.lump == 1) {
          this.temp.push(el);

        }
      });
      this.data.invoiceList = [];

      this.temp.forEach(e => {
        this.data.invoiceList.push(e)
      });
      console.log(this.data.invoiceList);
    }
    else if (this.singleVal) {
      this.getRangeList();

    }
  }



  onbackdet() {
    if (this.show_det == 'design') {
      this.show_det = 'variety'
    }
    else if (this.show_det == 'variety') {
      this.show_det = 'style'

    }
    // this.show_det = true;
    console.log(this.data.invoiceList);
    this.getRangeList()

  }



  getRangeList() {


    let params = {
      design_no: this.invoicedata.design_no,
      color: this.invoicedata.color,
      range: this.invoicedata.range,
      style: this.invoicedata.style,
      type: this.invoicedata.type,
      group: this.show_det
    };

    

    this.salesinvservice.getRangeList(params).then((res: any) => {
      this.dataList = res.data;
      this.data.invoiceList = res.data;
      this.calcGrand()


      var bottom = document.querySelector("#salesTbody");
      setTimeout(() => {
        bottom.scrollTop = bottom.scrollHeight;
      }, 500);

    });
  }
  getViewbarcode(type) {

    let ind = type;
    //  this.show_det = false;
    if (this.show_det == 'style') {
      this.show_det = 'variety'
    }
    else if (this.show_det == 'variety') {
      this.show_det = 'design'

    }
    this.invoicedata.design_no = this.data.invoiceList[ind].design_no,
    this.invoicedata.style = this.data.invoiceList[ind].style,
    this.invoicedata.type = this.data.invoiceList[ind].type

    let params = {
      design_no: this.invoicedata.design_no,
      style: this.invoicedata.style,
      type: this.invoicedata.type,
      range: this.invoicedata.range,
      group: this.show_det
    };
    console.log(params)
    this.salesinvservice.getRangeList(params).then((res: any) => {
      this.dataList = res.data;
      this.data.invoiceList = res.data;
     
      this.calcGrand()
      var bottom = document.querySelector("#salesTbody");
      setTimeout(() => {
        bottom.scrollTop = bottom.scrollHeight;
      }, 500);

    });

  }
  checkAll(evant, all) {
    if (evant.target.checked) {
      this.listSelected = this.data.invoiceList;
      $("input:checkbox").prop("checked", evant.target.checked);
    } else {
      $("input:checkbox").prop("checked", evant.target.checked);
      this.listSelected = [];
    }
  }
  checkInd(evant, ind, all) {
    if (evant.target.checked) {
      this.listSelected.push(all.data.invoiceList[ind]);
    } else {
      for (var k = 0; k < this.listSelected.length; k++) {
        if (
          this.listSelected[k].agent_name == all.data.invoiceList[ind].agent_name
        ) {
          this.listSelected.splice(k, 1);
          return;
        }
      }
    }
  }
  calcGrand(){
    this.gr_tot = 0;
    this.data.invoiceList.forEach(e => {
        this.gr_tot += e.tot_pcs
    });
    console.log(this.gr_tot,"check total value of gr");
  }
  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  getEditMode(ind) {
    this.mode = 'Edit';
    console.log(this.data.invoiceList);

  }

  getTbodyStyle() {
    let height = 300;
    if (this.tbody1) {
      height -= this.tbody1.nativeElement.offsetHeight;
    }
    const style = {
      display: "block",
      width: "1px",
      height: height + "px",
      "overflow-y": "scroll",
    };
    return style;
  }


}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/master/rangeStock/rangeStock.ts